<template>
  <div class="mdl-grid">
    <div class="mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone"></div>
    <div class="mdl-cell mdl-cell--8-col mdl-cell--8-col-tablet">
      <div class="profile mdl-grid">
        <div class="mdl-cell mdl-cell--12-col">
          <header class="profile__header">
            <img :src="$user.data.avatar" alt="Imagen de Perfil del Usuario">
            <h3 class="profile__header-title">{{ $user.data.name }}</h3>
            <div class="profile__header-subtitle">
              <span>{{ $user.data.role.toUpperCase() }}</span>
              <a href="#">{{ $user.data.email }}</a>
            </div>
          </header>
        </div>

        <div class="mdl-cell mdl-cell--12-col">
          <main class="profile__content">

          </main>
        </div>

        <div class="mdl-cell mdl-cell--12-col">
          <footer class="profile__footer">
            <!-- <h4>Mis Inmuebles</h4>
            <p>Listado de los inmuebles que estan bajo mi cargo.</p> -->
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      title: 'Mi Perfil'
    }
  },
  methods: {

  },
  mounted () {
    this.$endpoint.destroy()
    this.$title.show(this.title)
    // console.log(this.$endpoint)
  }
}
</script>

<style lang="css" scoped>
  .profile {
    background: #fff;
    text-align: center;
  }

  .profile__header {
    padding-bottom: 1.5rem;
    border-bottom: 1px solid #bebebe;
  }

  .profile__header img {
    border-radius: 50%;
  }

  .profile__header .profile__header-title {
    margin-bottom: 0;
  }

  .profile__header .profile__header-subtitle span {
    display: block;
    margin-bottom: 1rem;
    font-size: 1.15rem;
    font-weight: bold;
    color: grey;
  }

  .profile__header .profile__header-subtitle a {
    font-size: 1.15rem;
  }
</style>


// WEBPACK FOOTER //
// index.vue?a776fbb4